import { useWeb3React } from "@web3-react/core";
import React, { useState } from "react";
import { Routes, Route } from "react-router-dom";
// import { useRecoilState } from "recoil";

// import ColorThemeToggler from "./Components/UI/ColorThemeToggler";
import MintPage from "./Pages/MintPage";
import DefiExchange from "./Pages/DefiExchangePage";
// import Stake from "./Pages/Stake";
import StakeOld from "./Pages/StakeOld";

import CreateTokenLocker from "./Pages/Lockers/CreateTokenLocker";
import CreatePresale from "./Pages/CreatePresale";
import LaunchPadDashboard from "./Components/LaunchPad/LaunchPadDashboard/LaunchPadDashboard";
import TokenLocker from "./Pages/Lockers/TokenLocker/TokenLockers";
import TokenLockerInfo from "./Pages/TokenLockerInfo";
import PresaleInfoPage from "./Pages/PresaleInfoPage";
import StealthDashboard from "./Pages/StealthDashboard";

import Scan from "./Pages/Scan";

import ManagePresale from "./Pages/ManagePresale";

import { useEagerConnect, useInactiveListener, useValidAccount } from "./hooks";

import CreateLiquidityLocker from "./Pages/Lockers/Liquidity/CreateLiquidityLocker";
import LiquidityLocker from "./Pages/Lockers/Liquidity/LiquidityLocker";
import LPLockerInfo from "./Pages/Lockers/Liquidity/LPLockerInfo";
import WhitelistedPrivateSale from "./Pages/WhitelistedPrivateSale";
import SubmitDocuments from "./Pages/SubmitDocuments";
import TermsConditions from "./Pages/TermsConditions";
import PrivacyPolicy from "./Pages/PrivacyPolicy";
import CreateStealth from "./Pages/CreateStealth";
import StealthInfoPage from "./Pages/StealthInfoPage";
import StealthManagePage from "./Pages/StealthManagePage";
import LandingMain from "./Components/LandingPage/LandingMain";
import Profile from "./Pages/Profile";
import ProfileSettings from "./Pages/ProfileSettings";
import NewsFeed from "./Pages/NewsFeed";
import PostList from "./Components/Posts/PostList";

function Dashboard() {
    const { active } = useWeb3React();
    const { account } = useValidAccount();

    const [connected] = useState(active);

    const triedEager = useEagerConnect();
    useInactiveListener(!triedEager);

    return (
        <div className="flex flex-col w-full 2xl:px-64 xl:px-48 lg:px-32 px-6 pt-20 relative">
            <div className="absolute bg-landing-mask w-full top-0 left-0 aspect-[1/2] lg:aspect-[4/1]" />
            <Routes>
                <Route path="" element={<LandingMain />} />
                <Route path="defi-exchange" element={<DefiExchange />} />
                <Route
                    path="defi-exchange/:tokenAddress"
                    element={<DefiExchange />}
                />
                <Route path="create-stealth" element={<CreateStealth />} />
                <Route
                    path="stealth-dashboard"
                    element={<StealthDashboard />}
                />
                <Route
                    path="stealth-presale/:address"
                    element={<StealthInfoPage />}
                />
                <Route path="manage-stealth" element={<StealthManagePage />} />
                <Route
                    path="manage-stealth/:address"
                    element={<StealthManagePage />}
                />

                <Route
                    path="privateSale"
                    element={<WhitelistedPrivateSale />}
                />
                <Route path="create-launchpad" element={<CreatePresale />} />
                <Route path="launchpad" element={<LaunchPadDashboard />} />
                <Route path="presale/:address" element={<PresaleInfoPage />} />
                <Route path="manage-presale" element={<ManagePresale />} />

                <Route path="create-locker" element={<CreateTokenLocker />} />
                <Route
                    path="token-info/:tokenAddress"
                    element={<TokenLockerInfo />}
                />
                <Route path="token-lockers" element={<TokenLocker />} />
                <Route
                    path="create-liquidity"
                    element={<CreateLiquidityLocker />}
                />
                <Route path="lock-liquidity" element={<LiquidityLocker />} />

                <Route
                    path="liquidity/:tokenAddress"
                    element={<LPLockerInfo />}
                />
                <Route
                    path="stake"
                    element={
                        <StakeOld connected={connected} account={account} />
                    }
                />
                <Route path="scan" element={<Scan />} />
                <Route
                    path="mint"
                    element={
                        <MintPage connected={connected} account={account} />
                    }
                />
                <Route path="submit-document" element={<SubmitDocuments />} />
                <Route path="terms-conditions" element={<TermsConditions />} />
                <Route path="privacy-policy" element={<PrivacyPolicy />} />

                <Route path="profile" element={<Profile />} />
                <Route path="profile/:username" element={<Profile />} />
                <Route path="profile/settings" element={<ProfileSettings />} />

                <Route path="feeds/*" element={<NewsFeed />} />
                <Route path="posts/tag/:tag" element={<PostList />} />
            </Routes>
        </div>
    );
}

export default Dashboard;
